import React from 'react';
import Reveal from 'react-awesome-reveal';

// Import Custom Component
import ProductCard from '../../features/products/product-card';
import OwlCarousel from '../../features/owl-carousel';

// Import Settings
import { productSlider } from '../../../utils/data/slider';
import {fadeInLeftShorter} from '../../../utils/data/keyframes'
import useTranslation from "../../../utils/hooks/useTranslation";

export default function NewCollection ( props ) {
    const { t } = useTranslation();
    const { products, loading } = props;
    const sliderOptions = {
        ...productSlider,
        dots: true,
        responsive: { ...productSlider.responsive, 1200: { items: 5 } }
    };

    return (
        <section className="new-products-section pb-0">
            <div className="container">
                <div className="section-header">
                    <span className="section-eyebrow">{t('message.fresh_arrivals')}</span>
                    <h2>{t('message.new_arrivals')}</h2>
                    <p className="section-subtitle">{t('message.new_arrivals_subtitle')}</p>
                </div>

                <OwlCarousel adClass="products-slider modern-slider owl-theme custom-products" options={ sliderOptions }>
                    {
                        loading ?
                            [ 0, 1, 2, 3, 4 ].map( ( item, index ) =>
                                <div className="skel-pro skel-pro-grid" key={ "product-card" + index }></div>
                            )
                            :
                            products?.map( ( item ) => (
                                <Reveal keyframes={ fadeInLeftShorter } delay={ 100 } duration={ 1000 } triggerOnce={true} key={ "product-card" + item.id }>
                                    <ProductCard
                                        product={ item }
                                    />
                                </Reveal>
                            ) )

                    }
                </OwlCarousel>
            </div>
        </section>
    );
}